







































  import { Component, Prop, Vue } from 'vue-property-decorator'
  import { namespace } from 'vuex-class'

  const products = namespace('products')

  @Component
  export default class OneProductDownload extends Vue {
    name: string = 'one-product-download'
    @products.Getter getProductCertificates: any
    @products.Getter getProductDataSheets: any

    @Prop({
      type: String,
      required: true,
    })
    productId!: string

    get certificates() {
      return this.productId && this.getProductCertificates(this.productId)
    }

    get productDataSheets() {
      return this.productId && this.getProductDataSheets(this.productId)
    }

    get hasCertificates() {
      return this.certificates && this.certificates.length > 0
    }

    get hasDataSheets() {
      return this.productDataSheets && this.productDataSheets.length > 0
    }
  }
